export const InsuredRelationshipWithOwnerOptions = [
    { value: "", label: "" },
    { value: "Spouse", label: "Spouse" },
    { value: "Mother", label: "Mother" },
    { value: "Father", label: "Father" },
    { value: "Child", label: "Child" },
    { value: "Brother", label: "Brother" },
    { value: "Sister", label: "Sister" },
    { value: "Grandchild", label: "Grandchild" },
    { value: "Friend", label: "Friend" },
    { value: "Trust", label: "Trustee" },
    { value: "Self", label: "Self" },
    { value: "Other", label: "Other" },
];



// WEBPACK FOOTER //
// ./src/components/Helpers/Lists/InsuredRelationshipWithOwnerOptions.js